/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_TitleInputs */



/**
* | output |
* | --- |
* | "Import members from CSV" |
*
* @param {Team_Manager_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_title = /** @type {((inputs?: Team_Manager_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer des membres depuis un CSV")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitglieder aus CSV importieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa membri da CSV")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт участников из CSV")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar miembros desde CSV")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从 CSV 导入成员")
	if (locale === "ja") return /** @type {LocalizedString} */ ("CSV からメンバーを読み込む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("CSV से सदस्य इंपोर्ट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importar membros de CSV")
	return /** @type {LocalizedString} */ ("Import members from CSV")
});